import React from 'react'
import { injectIntl } from 'react-intl'

const Address = ({intl}) => (
    <div>
    <h3>Goldfish</h3>

    <address>
        <a href="https://www.google.fi/maps/place/Korkeavuorenkatu+21,+Helsinki/" rel="noopener noreferrer">Korkeavuorenkatu 21</a><br />
        Helsinki
    </address>

    <a href="mailto:info@goldfish.fi">info@goldfish.fi</a>
    <a href="tel:+358103232980">{intl.locale==='en'?'+358 ':'0'}10 323 2980</a>

    <a href="https://www.facebook.com/Goldfish-Helsinki-288458664991654/" className="some facebook">Facebook</a>
    <a href="https://www.instagram.com/goldfish_helsinki/" className="some instagram">Instagram</a>
    <a href="https://www.linkedin.com/company/bw-restaurants-oy/" className="some linkedin">LinkedIn</a>
    </div>
)

export default injectIntl(Address);


// WEBPACK FOOTER //
// ./src/components/Address.js